import React, { useEffect, useState } from "react";
import FnolViewerComponentWrapper from "components/FnolViewerComponentWrapper";
import styles from "components/FnolViewer.module.css";
import { setRecoil } from "recoil-nexus";
import { DateTime } from "luxon";
import { dateTimeWhenFNOLOpenedState } from "atoms/dateTimeWhenFNOLOpenedState";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

const FnolViewer = (props) => {
  const fnolQuestionSetStructureState = props.fnolQuestionSetStructureState;
  const fnolQuestionSet = props.fnolQuestionSet;
  const userId = props.userId;
  const [loading, setLoading] = useState(true);
  const [fnolComponents, setFnolComponents] = useState([]);

  useEffect(() => {
    let currentDateTimeString = DateTime.now().toISO({ includeOffset: false });
    setRecoil(dateTimeWhenFNOLOpenedState, currentDateTimeString);
  }, []);

  useEffect(() => {
    setLoading(true);

    setTimeout(() => {
      const renderedComponents = fnolQuestionSet.map((fnolComponent) => (
        <div className={styles.component} key={"div_" + fnolComponent.componentKey}>
          {renderFnolComponent(fnolComponent)}
        </div>
      ));

      setFnolComponents(renderedComponents);
      setLoading(false);
    }, 1000);
  }, [fnolQuestionSet]);

  const renderFnolComponent = (fnolComponent) => {
    const lazyLoadedFnolComponent = React.lazy(() => import("components/fnol-components/" + fnolComponent.controlType));
    return (
      <FnolViewerComponentWrapper
        key={"fvc_" + fnolComponent.componentKey}
        uiFnolComponent={lazyLoadedFnolComponent}
        fnolComponent={fnolComponent}
        customerId={fnolQuestionSetStructureState.customerId}
        fnolQuestionSetId={fnolQuestionSetStructureState.id}
        userId={userId}
      />
    );
  };

  return (
    <>
      {loading ? (
        <Box sx={{ display: "flex", pt: 5, justifyContent: "center" }}>
          <CircularProgress />
        </Box>
      ) : (
        <div>{fnolComponents}</div>
      )}
    </>
  );
};

export default FnolViewer;
